import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { Icon, useStylesV2 } from '@kubit/web-ui-product-components';
//Constants
import { STYLES_NAME } from '../../constants/stylesName';
import { IconVariantsType } from '../../designSystem/reloaded/commons/components/variants';
const IconComponent = ({ color, ...props }) => {
    const styles = useStylesV2({
        styleName: STYLES_NAME.ICON,
        variantName: IconVariantsType.DEFAULT,
    });
    return _jsx(Icon, { color: color ?? styles?.icon?.color, ...props });
};
export { IconComponent };
//# sourceMappingURL=icon.component.js.map